export const CHAT_HISTORY_KEY = "vviinn-chat-history";
